<div class="v-pageName">{{pageName}}</div>

<div class="qmig-card">
    <div class="qmig-card-body">
        <form class="form qmig-Form" [formGroup]="ChangePasswordForm">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div class="form-group">
                        <label class="form-label d-required" for="targtetConnection">Full Name</label>
                        <input class="form-control" type="text" id="name" value="{{user.unique_name}}"
                            placeholder="UserName" disabled>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div class="form-group">
                        <label class="form-label d-required" for="targtetConnection">Email ID</label>
                        <input class="form-control" type="text" id="Email" value="{{user.email}}" disabled
                                placeholder="Email">
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-6"></div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div class="form-group">
                        <label class="form-label d-required" for="targtetConnection">Current Password</label>
                        <input class="form-control" [type]="!text_check ? 'CurrentPassword' : 'password'"
                            id="CurrentPassword" formControlName="CurrentPassword"
                            placeholder="Current Password">
                        <span [ngClass]="text_check ? 'mdi mdi-eye-off' : 'mdi mdi-eye'" class="eye_design"
                            (click)="sendEye()"></span>
                        @if ( f.CurrentPassword.touched && f.CurrentPassword.invalid) {
                        <p class="text-start text-danger mt-1">
                            @if (f.CurrentPassword.errors.required) {Current Password is Required }
                        </p>
                        }
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div class="form-group">
                        <label class="form-label d-required" for="targtetConnection">New Password</label>
                        <input class="form-control" [type]="!text_checks ? 'NewPassword' : 'password'"
                            id="NewPassword" formControlName="NewPassword" placeholder="New Password">
                        <span [ngClass]="text_checks ? 'mdi mdi-eye-off' : 'mdi mdi-eye'" class="eye_design"
                            (click)="sendEyes()"></span>
                        @if ( f.NewPassword.touched && f.NewPassword.invalid) {
                        <p class="text-start text-danger mt-1">
                            @if (f.NewPassword.errors.required) {New Password is Required }
                            @if (f.NewPassword.errors.minlength) {New Password must be at least 8 characters. }
                        </p>
                        }
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div class="form-group">
                        <label class="form-label d-required" for="targtetConnection">Confirm Password</label>
                        <input class="form-control" type="password" id="ConfirmPassword"
                            formControlName="ConfirmPassword" placeholder="Confirm Password">
                        @if ( f.ConfirmPassword.touched && f.ConfirmPassword.invalid) {
                        <p class="text-start text-danger mt-1">
                            @if (f.ConfirmPassword.errors.required) {Confirm Password is Required }
                            @if (f.ConfirmPassword.errors.confirmedValidator) {New Password and Confirm Password must be match. }
                        </p>
                        }
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 mt-4 pt-1">
                    <div class="form-group">
                        <button class="btn btn-upload w-100 " [disabled]="ChangePasswordForm.invalid"
                        (click)="ChangePassword(this.ChangePasswordForm.value)"> <span class="mdi mdi-lock-reset"
                                aria-hidden="true"></span>Update Password @if(Add_spin){<app-spinner/>}</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>